
import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AppointmentCalendar from './AppointmentCalendar';
import AppointmentList from './AppointmentList';
import { PeriodSelector } from './PeriodSelector';
import { Loader2 } from 'lucide-react';
import { Appointment, ViewPeriod, ViewMode } from '@/types/dashboard';

interface AppointmentViewerProps {
  appointments: Appointment[];
  period: ViewPeriod;
  onPeriodChange: (period: ViewPeriod) => void;
  onAppointmentClick: (appointment: Appointment) => void;
  loading: boolean;
  psychologistId?: string;
}

export const AppointmentViewer: React.FC<AppointmentViewerProps> = ({
  appointments,
  period,
  onPeriodChange,
  onAppointmentClick,
  loading,
  psychologistId
}) => {
  const [viewMode, setViewMode] = useState<ViewMode>('calendar');

  return (
    <div className="bg-card rounded-lg shadow-sm p-4 mt-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-4">
        <Tabs 
          value={viewMode} 
          onValueChange={(value) => setViewMode(value as ViewMode)}
          className="w-full sm:w-auto"
        >
          <TabsList>
            <TabsTrigger value="calendar">Calendário</TabsTrigger>
            <TabsTrigger value="list">Lista</TabsTrigger>
          </TabsList>
        </Tabs>
        
        <PeriodSelector 
          value={period}
          onChange={onPeriodChange}
        />
      </div>
      
      {loading ? (
        <div className="flex justify-center items-center py-20">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : (
        <>
          {viewMode === 'calendar' ? (
            <AppointmentCalendar 
              psychologistId={psychologistId}
              onDateSelect={(date) => {}}
            />
          ) : (
            <AppointmentList 
              psychologistId={psychologistId}
              onViewNotes={(appointmentId) => {}}
            />
          )}
        </>
      )}
    </div>
  );
};

export default AppointmentViewer;
